export default "__VITE_ASSET__CTa9jJCM__";